;(function() {
/* @ngInject */
function ContactCityController(ModalImg, ModalMap) {
    let vm = this;

    vm.openImage = openImage;
    vm.openMap = openMap;

    function openImage() {
        ModalImg(vm.fullImg)
            .add()
            .result
            .then();
    }

    function openMap() {
        ModalMap(vm.googleMap, vm.googleMarker)
            .add()
            .result
            .then();
    }
}

angular.module("firmaren")
    .component("contactCity", {
        templateUrl: "/app/shared/contact-city/contact-city.html",
        controller: ContactCityController,
        controllerAs: "vm",
        bindings: {
            city: "@",
            address: "@",
            email: "@",
            phone: "<",
            showQuestionButton: "<",
            workingDaysSk: "@",
            workingDaysEn: "@",
            mapImg: "@",
            smallImg: "@",
            fullImg: "@",
            googleMap: "<",
            googleMarker: "<"
        }
    });
}());
